module.exports = __webpack_public_path__ + "media/images/riders/KADE_EDWARDS-9d5f70653bd9d25e213e30c17e42c27f.png";